import * as actions from '../../actions/actions'

const initialState = {
  campaigns: [],
  error: null
}

export default function campaign(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_CAMPAIGN_SUCCESS:
      return fetchCampaignSuccess(state, action)
    case actions.FETCH_CAMPAIGN_FAILURE:
      return fetchCampaignFailure(state, action)
    case actions.ENABLE_CAMPAIGN_SUCCESS:
      return enableCampaignSuccess(state, action)
    case actions.ENABLE_CAMPAIGN_FAILURE:
      return enableCampaignFailure(state, action)
    case actions.DISABLE_CAMPAIGN_SUCCESS:
      return disableCampaignSuccess(state, action)
    case actions.DISABLE_CAMPAIGN_FAILURE:
      return disableCampaignFailure(state, action)
    case actions.DELETE_CAMPAIGN_SUCCESS:
      return deleteCampaignSuccess(state, action)
    case actions.DELETE_CAMPAIGN_FAILURE:
      return deleteCampaignFailure(state, action)
    default:
      return state
  }
}

const enableCampaignSuccess = (state, action) => {
  return {
    ...state,
    campaigns: action.campaigns
  }
}

const enableCampaignFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const disableCampaignSuccess = (state, action) => {
  return {
    ...state,
    campaigns: action.campaigns
  }
}

const disableCampaignFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const fetchCampaignSuccess = (state, action) => {
  return {
    ...state,
    campaigns: action.campaigns
  }
}

const fetchCampaignFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const deleteCampaignSuccess = (state, action) => {
  return {
    ...state,
    campaigns: action.campaigns
  }
}

const deleteCampaignFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}